// ─────────────────────────────────────────────────────────────
// Demographics — INE Censos 2021 baseline + bucketing logic
// ─────────────────────────────────────────────────────────────
// aging_index = aantal 65+ per 100 jongeren <15. National PT
// gemiddelde 2021 ≈ 182, NL ≈ 128. Hoger = sterker vergrijsd.
//
// Buckets en interpretaties zijn afgestemd op de behoefte van
// een gezin met jonge kinderen (peers / schoolpopulatie).

export const REFERENCE = {
  pt: { median_age: 46.8, aging_index: 182, pct_youth: 12.9, pct_elderly: 23.6 },
  nl: { median_age: 42.2, aging_index: 128, pct_youth: 15.7, pct_elderly: 20.2 },
};

export const AGING_BUCKETS = [
  { id: "young",        max:  130, label: "Jong",              dot: "🟢", interpretation: "Jongere bevolking dan NL-gemiddelde. Volop kinderen voor schoolpopulatie en speelmaatjes." },
  { id: "balanced",     max:  180, label: "Balans",            dot: "🟢", interpretation: "Rond PT-gemiddelde. Werkende bevolking nog stevig, voldoende gezinnen met kinderen." },
  { id: "aging",        max:  230, label: "Vergrijzend",       dot: "🟡", interpretation: "Boven PT-gemiddelde. Minder gezinnen, kleinere klassen. Voor kinderen 0-12: minder leeftijdsgenoten in de buurt." },
  { id: "heavily-aged", max:  300, label: "Sterk vergrijsd",   dot: "🔴", interpretation: "Sterk vergrijsd. Schoolklassen klein, weinig peers voor de kinderen. Gemeenschap rust op senioren." },
  { id: "shrinking",    max: 9999, label: "Krimpend",          dot: "⚫", interpretation: "Demografisch krimpend en extreem vergrijsd. Overweeg leefbaarheid en voorzieningen op lange termijn." },
];

export function bucketForAgingIndex(ai) {
  if (ai == null || isNaN(ai)) return null;
  return AGING_BUCKETS.find(b => ai < b.max) || AGING_BUCKETS[AGING_BUCKETS.length - 1];
}

export function popTrendLabel(pct) {
  if (pct == null || isNaN(pct)) return null;
  if (pct < -3) return { id: "shrinking-strong", label: "sterke krimp" };
  if (pct < -1) return { id: "shrinking",        label: "krimpend"     };
  if (pct <  1) return { id: "stable",           label: "stabiel"      };
  if (pct <  5) return { id: "growing",          label: "groeiend"     };
  return                { id: "growing-strong",  label: "sterke groei" };
}

export function hasDemographics(facts) {
  return facts && facts.aging_index != null && facts.median_age != null;
}
